const TaxDescription = {
  key: 'The key of the tax',
  description: 'The title of the tax',
};

export default TaxDescription;
